import keyMirror from 'keymirror';
import { withLanguageLocale } from '../../services/Helper';

export const chapterDetailsActionTypes = keyMirror({
	GET_CHAPTER_DETAILS: null,
	GET_CHAPTER_DETAILS_SUCCESS: null,
	GET_CHAPTER_DETAILS_ERROR: null,

	GET_CHAPTER_DETAILS_PARAGRAPHS: null,
	GET_CHAPTER_DETAILS_PARAGRAPHS_SUCCESS: null,
	GET_CHAPTER_DETAILS_PARAGRAPHS_ERROR: null,

	GET_CHAPTER_DETAILS_SUMMARY: null,
	GET_CHAPTER_DETAILS_SUMMARY_SUCCESS: null,
	GET_CHAPTER_DETAILS_SUMMARY_ERROR: null,

	GET_PAUSED_DIAGNOSTIC_TEST: null,
	GET_PAUSED_DIAGNOSTIC_TEST_SUCCESS: null,
	GET_PAUSED_DIAGNOSTIC_TEST_ERROR: null,

	GET_TO_DO_TOPICS: null,
	GET_TO_DO_TOPICS_SUCCESS: null,
	GET_TO_DO_TOPICS_ERROR: null,

	CLEAR_PARAGRAPHS_DATA: null,
	CLEAR_SUMMARY_DATA: null,
	CLEAR_TODO_DATA: null,
	CLEAN_CHAPTER_DETAILS_STATE: null,

	GET_CHAPTER_RELATED_QUESTIONS: null,
	GET_CHAPTER_RELATED_QUESTIONS_SUCCESS: null,
	GET_CHAPTER_RELATED_QUESTIONS_ERROR: null,
});

export const getChapterDetailsTabs = (chapter, t, hideSummary, hideTests) =>
	getChapterTabs(t, hideSummary, hideTests).map((item) => ({
		...item,
		link: withLanguageLocale(`/chapters/${chapter}${item.value ? `/${item.value}` : ''}`),
	}));

export const getChapterTabs = (t, hideSummary, hideTests) => [
	{ title: t('chapter_details.tabs.paragraphs'), value: '', index: 0 },
	...(hideSummary
		? []
		: [{ title: t('chapter_details.tabs.summary'), value: 'summary', index: 1 }]),
	...(hideTests ? [] : [{ title: t('chapter_details.tabs.test'), value: 'test', index: 2 }]),
];

export const getChapterResultsSubTabs = (t) => [
	{
		title: t('chapter_details.test_results.tabs.to_practice'),
		value: 'practice',
		index: 0,
	},
	{ title: t('chapter_details.test_results.tabs.results'), value: 'results', index: 1 },
];
